import { gql, useMutation } from '@apollo/client'
import { CreateCookieTokenMutation } from 'types/graphql'
import { shouldFetchCookieToken, setSessionCookie } from 'api/authCookies'

export const createCookieTokenMutation = gql`
  mutation CreateCookieToken {
    createCookieToken {
      payload
    }
  }
`

export const useCreateCookieToken = () => {
  const [runMutation, { loading, error }] = useMutation<CreateCookieTokenMutation>(createCookieTokenMutation, {
    onCompleted: ({ createCookieToken: { payload } }) => {
      setSessionCookie(payload)
    }
  })

  const createCookieToken = () => {
    if (shouldFetchCookieToken() && !loading && !error) {
      runMutation()
    }
  }

  return { createCookieToken }
}
